import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import { Tabs, Tab } from 'components/tabs'

import { productTabs } from './data'
import * as S from './styles'
import { TabContent } from './tab-content'

const Products = memo(() => (
  <S.Products>
    <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
      <Col>
        <S.Content>
          <S.Header>
            <SectionLabel
              size="body1"
              weight="bold"
              color="white"
              barColor="var(--colors-blue-background-strong-default)"
            >
              Nossos produtos
            </SectionLabel>

            <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-text-contrast)">
                Soluções financeiras
              </Text>{' '}
              para você ir mais longe
            </Text>

            <Text size="heading5" weight="regular" color="var(--colors-neutral-text-contrast-default)">
              Conheça suas opções e escolha a melhor para você:
            </Text>
          </S.Header>

          <S.TabsWrapper>
            <Tabs
              activeTabIndex={0}
              slidingIndicator
              autoCenterActive
              dataLayer={productTabs.map((tab, index) => ({
                index,
                category: 'Clique',
                action: 'Portfólio',
                label: `Tab Button - ${tab.name.replace(/\n/g, ' ')}`
              }))}
            >
              {productTabs.map(tab => (
                <Tab key={tab.link} name={tab.name}>
                  <TabContent {...tab} />
                </Tab>
              ))}
            </Tabs>
          </S.TabsWrapper>
        </S.Content>
      </Col>
    </Grid>
  </S.Products>
))

Products.displayName = 'Products'

export default Products
